module.exports = {"TXTWCL_RatingX_N0_out_of_N1_stars":{"id":"TXTWCL_RatingX_N0_out_of_N1_stars","defaultMessage":"Note : {0} étoiles sur {1}"}}